var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.store.state.loading || _vm.store.state.loadingMoreRecipes)?_c('Loader',{staticClass:"u-flex u-mt--l u-mb--xl u-ml--a u-mr--a",attrs:{"size":"large","color":"medium-gray"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }